import { $adminApi } from "../../../api";
import { Thread } from "../types";
import { useNavigate } from "react-router-dom";
import styles from "./RecentMessages.module.css";
import { getTimeToNowString } from "@utils/time";

export function RecentMessages({ thread }: { thread: Thread }) {
  const { data: threads } = $adminApi.useSuspenseQuery("get", "/v2/admin/threads/", {
    params: {
      query: {
        user: [thread.user.id],
        ordering: ["-last_message_at"],
      },
    },
  });

  const navigate = useNavigate();

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-m)" }}>
      <div>
        {threads.results.map((t) => (
          <InboxMessage
            id={t.id}
            key={t.id}
            selected={thread.id === t.id}
            onClick={(id) => navigate(`/messages/${id}`)}
            message={t.subject || "No subject"}
            secondaryMessage={t.latest_message_preview}
            time={t.last_message_at}
          />
        ))}
      </div>
    </div>
  );
}

function InboxMessage({
  id,
  message,
  secondaryMessage,
  selected,
  status,
  time,
  onClick,
}: {
  id: string;
  message: string;
  secondaryMessage?: string;
  selected?: boolean;
  status?: "unread" | "read";
  time: string;
  onClick: (messageId: string) => void;
}) {
  return (
    <div
      className={`${styles.inboxMessage} ${selected ? styles.selected : ""}`}
      onClick={() => onClick(id)}
    >
      <div className={styles.content}>
        <div
          className={`fontSize--s ${status === "unread" ? "fontWeight--bold" : "fontWeight--normal"}`}
        >
          {status === "unread" ? <div className={styles.indicator} /> : null}
          <span>{message}</span>
        </div>
        <div className="fontSize--xs">{secondaryMessage}</div>
      </div>
      <div className={styles.time}>{getTimeToNowString(time)}</div>
    </div>
  );
}

export { InboxMessage };
